import { render, staticRenderFns } from "./DrugsMonthlyByDrug.vue?vue&type=template&id=511ffc99&lang=pug"
import script from "./DrugsMonthlyByDrug.vue?vue&type=script&lang=js"
export * from "./DrugsMonthlyByDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrugNameDesc: require('/home/docker/code/frontend/components/DrugNameDesc.vue').default})
